<template>
    <div class="layer dialogLayer mask50" v-show="visible" @click="close();">

        <div class="dialog white_bg" :class="{roundBorder8 : roundBorder}" :style="'width:' + width + 'px'">

            <header class="dialogHeader generalPagePaddingH relative paddingV8 alignCenter bottomBorderB3B3B3">
                <div class="inner font18r orange">
                    {{title}}
                </div>
                <span class="closeButton fr font24r absolutePosition" style="right: 10px; top: 7px;"
                      @click="close()">&times;</span>
            </header>

            <div class="dialogBody" style="padding: 0 0 20px;">
                <div class="alignC orange font14r" style="line-height: 38px;">
                    亲爱的小主，您有一则消息需要查收！
                </div>
                <div class="font14r" style="padding: 0 15px;">
                    <div class="color101010">消息内容：</div>
                    <ul class="marginT12 noListStyle paddingL12" style="line-height: 20px;">
                        <li v-for="(dataItem, index) in dataList" :key="index">{{index + 1}}、
                            {{dataItem}}
                        </li>
                    </ul>
                    <div class="paddingL12" style="margin-top: 40px;">
                        新的一天，由师讯伴您同行，祝您工作愉快~
                    </div>
                </div>
                <button class="marginT16 font14r okButton block centered" style="width: 238px; height: 30px; line-height: 30px;
                    border-radius: 4px; " @click="ok()">
                    立即查收
                </button>
            </div>

        </div>
    </div>

</template>

<script>
import dialogPart from '../part/dialogPart';
import appHelper from "@util/appHelper";

const config = {
    apiConfig : {
        list : {
            url: 'portal/v4/index/getMessageTitleList',
            dataPath : 'data'
        }
    }
};
export default {
    name: "notificationDialog",
    extends : dialogPart,
    props : {
        width: {
            type : Number,
            default : 320
        }
    },
    data() {
        return {
            title : '发现新消息',
            apiConfig : config.apiConfig,
            enableDataList : true,
            pageSize : 1
        }
    },
    methods : {
        onLoadDataList(){
            if (this.dataList.length)
            {
                this.show();
            }
        },
        ok() {
            appHelper.goToPage('meMessageIndex');
            this.close();
        }
    },
    mounted() {

        const me = this;
        // load data after check login
        appHelper.checkLogin((error, result) => {

            if (error) {
                return;
            }

            // 游客
            if (!result)
            {
                return;
            }

            me.loadDataList();
        });
    }
}
</script>
<style lang="scss" scoped>
.dialogLayer {
    display: grid;
    align-content: center;
    justify-content: center;
}
.dialog {
    min-height: 120px;
}
.orange {
    color: #F4950E;
}
.okButton {
    background-color: #F4950E;
    color: white;
    border: none;
}
</style>
